import i18next from "src/i18n/config";
import { eventVersionService } from "src/services/eventVersionService/eventVersionService";
import RouteService from "src/services/routeService";
import { EventEntityFilter, stringifyEventParams, toApiPageIndex } from "src/store/api/events/entities";
import { transformErrorResponse } from "src/store/helpers";
import { ListResponse, PaginatedResponse } from "src/types";

import { EventReport } from "@dashboard/devices/types";

import { AdminBuilder } from "./tags";

export type GetAllEventsParams = {
    pageIndex?: number;
    pageSize?: number;
    levels?: API.EventLevel[];
    workspaceIds?: number[];
    groupIds?: number[];
    entities?: EventEntityFilter[];
    createdFrom?: string;
    createdTo?: string;
    searchTerm?: string;
    sortCriteria?: string;
    sortDirection?: "ascending" | "descending";
};

const events = (builder: AdminBuilder) => ({
    getAllEvents: builder.query<ListResponse<EventReport>, GetAllEventsParams>({
        providesTags: ["AdminEvents"],
        transformErrorResponse: (err) => transformErrorResponse(err, i18next.t("common:error.events.failedToFetchEvents")),
        transformResponse: (response: PaginatedResponse<API.EventReport>) => ({
            ...response,
            list: eventVersionService.normalizeList(response.list),
        }),
        query: async (params) => {
            const base = await RouteService.getAdminEventsRoute();
            const paramsToSend = { ...params, pageIndex: toApiPageIndex(params.pageIndex) };
            return {
                url: `${base}events/all`,
                params: paramsToSend,
                paramsSerializer: () => stringifyEventParams(paramsToSend),
            };
        },
    }),
});

export default events;
